import { render } from "./roundtable.vue?vue&type=template&id=398d56a8&scoped=true"
import script from "./roundtable.vue?vue&type=script&lang=js"
export * from "./roundtable.vue?vue&type=script&lang=js"

import "./roundtable.vue?vue&type=style&index=0&id=398d56a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-398d56a8"

export default script